import { render, staticRenderFns } from "./upgrade-modal.vue?vue&type=template&id=638c3410&scoped=true&"
import script from "./upgrade-modal.vue?vue&type=script&lang=ts&"
export * from "./upgrade-modal.vue?vue&type=script&lang=ts&"
import style0 from "./upgrade-modal.vue?vue&type=style&index=0&id=638c3410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638c3410",
  null
  
)

export default component.exports